import { AppState } from "../rootReducer";

export const getUserClient = (state: AppState) => state.signup?.userClient || {};

export const getSignupRequesting = (state: AppState) =>
  state.signup?.requesting || false;

export const getSignupGoalNumber = (state: AppState) =>
  state.signup?.goalNumber || 3;

export const getSignupFirstName = (state: AppState) =>
  state.signup?.firstName || "";

export const getSignupLastName = (state: AppState) =>
  state.signup?.lastName || "";

export const getSignupProgressRatio = (state: AppState) =>
  state.signup?.progressRatio || 1;

export const getSignupError = (state: AppState) => state.signup?.error || "";

export const getSignupEmail = (state: AppState) => state.signup?.email || "";

export const getSignupPassword = (state: AppState) =>
  state.signup?.password || "";

export const getSignupAccessCode = (state: AppState) =>
  state.signup?.accessCode || "";

export const getSignupErrors = (state: AppState) =>
  state.signup?.errors || { password: "", email: "", name: "" };

export const getSignupClientName = (state: AppState) =>
  state.signup?.clientName || "Microdoing";

export const getSignupPolicy = (state: AppState) =>
  state.signup?.signupPolicy || "";
